import { useEffect, useRef } from 'react';

import { PlayoutStoreV2Type } from '@kaltura-ott/tvpil-shared';
import { PlayableAsset } from '@kaltura-ott/tvpil-shared/lib/stores/entities/PlayableAsset';

import { useAppStore, useCleanupState } from 'hooks';
import { globalStorage } from 'services/globalStorage';

export const useInitializationHook = (isPlayerCondition: boolean) => {
  const [loaded, setLoaded] = useCleanupState(() => false);
  const playableAsset = useRef<PlayableAsset | undefined>(undefined);
  const hasComponentAlreadyMounted = useRef(false);
  const {
    appStore: { playoutStoreV2: playoutStore, lastWatchedLinear },
  } = useAppStore();
  const focusAssetId = globalStorage?.focusAssetV2?.id;

  useEffect(() => {
    async function effect() {
      await playoutStore.init({
        id: focusAssetId,
        type: PlayoutStoreV2Type.LIVE,
        autoplayNextProgram: true,
        isMaxiPlayer: true,
        mosaic: {
          externalId: lastWatchedLinear.mainHeroRail?.lastWatchedSubLinearExternalId,
        },
      });

      globalStorage.clearFocusAsset();

      hasComponentAlreadyMounted.current = true;
      playableAsset.current = playoutStore.currentAsset;

      setLoaded(!!playoutStore.currentAsset);
    }

    if (focusAssetId && playoutStore && !(hasComponentAlreadyMounted.current && isPlayerCondition)) {
      setLoaded(false);
      effect();
    }

    return () => {
      if (focusAssetId) {
        hasComponentAlreadyMounted.current = false;
      }
    };
  }, [playoutStore, focusAssetId, setLoaded, isPlayerCondition]);

  return { loaded, playableAsset: playableAsset.current };
};
